export async function connectWallet() {
  if (typeof window === "undefined") {
    throw new Error("Browser environment not detected.");
  }

  if (!window.ethereum || !window.ethereum.isMetaMask) {
    throw new Error("MetaMask not detected. Please install MetaMask!");
  }

  const provider = window.ethereum;

  if (typeof provider.request !== "function") {
    throw new Error("MetaMask provider is not ready.");
  }

  const accounts = await provider.request({ method: "eth_requestAccounts" });
  if (!accounts?.length) throw new Error("No accounts found in MetaMask.");

  return { provider, address: accounts[0] };
}

export async function signMessageAndSend({ provider, address, endpoint }) {
  if (!provider) throw new Error("No provider supplied for signing.");

  const message = `Login with MetaMask at ${
    window.location.host
  } on ${new Date().toISOString()}`;

  let signature;
  try {
    signature = await provider.request({
      method: "personal_sign",
      params: [message, address],
    });
  } catch (err) {
    if (err.code === 4001) throw new Error("User denied message signature.");
    throw err;
  }

  if (endpoint) {
    const axios = (await import("axios")).default;
    await axios.post(
      endpoint,
      { address, message, signature },
      { withCredentials: true },
    );
  }

  return { address, message, signature };
}

export const blockchainfeatures = {
  connectWallet,
  signMessageAndSend,
};
